/* eslint-disable */

import { HiX } from "react-icons/hi";
import Links from "./components/Links";
import { Link, useLocation } from "react-router-dom";
import { MdKeyboardArrowDown } from "react-icons/md";
import { useState } from 'react';

import SidebarCard from "components/sidebar/componentsrtl/SidebarCard";
import routes from "routes.js";

const Sidebar = ({ open, onClose, routes: routesProp }) => {
  const menuRoutes = routesProp ?? routes;

  return (
    <div
      className={`sm:none duration-175 linear fixed !z-50 flex h-screen w-[320px] max-w-[320px] min-w-[320px] flex-col bg-gradient-to-b from-green-600 to-green-700 pb-10 shadow-2xl shadow-white/5 transition-all dark:!bg-green-800 dark:text-white md:!z-50 lg:!z-50 xl:!z-0 ${
        open ? "translate-x-0" : "-translate-x-96"
      }`}
    >
      <span
        className="absolute top-4 right-4 block cursor-pointer xl:hidden text-white"
        onClick={onClose}
      >
        <HiX />
      </span>

      <div className={`mx-[56px] mt-[50px] flex items-center`}>
        <div className="mt-1 ml-1 h-2.5 font-poppins text-[26px] font-bold uppercase text-white dark:text-white">
          RCN <span className="font-medium"> WEB</span>
        </div>
      </div>
      <div className="mt-[58px] mb-7 h-px bg-white/30" />
      {/* Nav item */}

      <div className="flex-1 overflow-y-auto scrollbar-thin scrollbar-thumb-white/20 scrollbar-track-transparent">
        <ul className="mb-auto pt-1">
          <SidebarLinks routes={menuRoutes} />
        </ul>
      </div>

      {/* Free Horizon Card */}
      <div className="flex justify-center">
        <SidebarCard />
      </div>

      {/* Nav item end */}
    </div>
  );
};

const SidebarLinks = ({ routes: menuRoutes }) => {
  const location = useLocation();
  const [openSubmenus, setOpenSubmenus] = useState({});
  const routes = menuRoutes ?? [];

  const activeRoute = (routePath) => {
    if (!routePath) return false;
    return location.pathname.includes(routePath);
  };

  const toggleSubmenu = (key) => {
    setOpenSubmenus((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const isHiddenRoute = (route) => {
    const hiddenValue = typeof route.hidden === "function" ? route.hidden() : route.hidden;
    return hiddenValue;
  };

  const getVisibleChildren = (route) => {
    if (!route.submenu) return [];
    return route.submenu.filter((item) => !isHiddenRoute(item));
  };

  const getFullPath = (route) => {
    if (!route.path) return "";
    if (route.layout) {
      return `${route.layout}/${route.path}`;
    }
    return route.path.startsWith("/") ? route.path : `/${route.path}`;
  };

  const renderMenuItems = (menuRoutes, level = 0, parentKey = "") => {
    return menuRoutes.map((route, index) => {
      if (!route.name && !route.submenu) return null;
      if (isHiddenRoute(route)) return null;

      const key = parentKey ? `${parentKey}-${route.path || index}` : `${route.path || index}`;
      const visibleChildren = getVisibleChildren(route);
      const hasChildren = visibleChildren.length > 0;
      const isActive = activeRoute(route.path);
      const textClass = isActive ? "font-bold text-white" : "font-medium text-white/70";
      const paddingLeft = 32 + level * 12;
      const itemStyle = { paddingLeft: `${paddingLeft}px`, paddingRight: "32px" };
      const containerClasses = "relative mb-3 flex hover:cursor-pointer hover:bg-white/10 rounded-lg transition-all duration-200";

      if (hasChildren) {
        return (
          <div key={key}>
            <div onClick={() => toggleSubmenu(key)} className={containerClasses}>
              <li className="my-[3px] flex cursor-pointer items-center w-full" style={itemStyle}>
                {route.icon && <span className={textClass}>{route.icon}</span>}
                <p className={`leading-1 ml-4 flex ${textClass}`}>
                  {route.name}
                </p>
                <span
                  className="ml-auto transition-transform duration-200 text-white"
                  style={{ transform: openSubmenus[key] ? "rotate(180deg)" : "rotate(0deg)" }}
                >
                  <MdKeyboardArrowDown className="h-5 w-5" />
                </span>
              </li>
            </div>
            <div
              className="overflow-hidden transition-all duration-200"
              style={{
                maxHeight: openSubmenus[key] ? "1000px" : "0",
                opacity: openSubmenus[key] ? 1 : 0,
              }}
            >
              {renderMenuItems(visibleChildren, level + 1, key)}
            </div>
          </div>
        );
      }

      const fullPath = getFullPath(route);

      return (
        <Link key={key} to={fullPath}>
          <div className={containerClasses}>
            <li className="my-[3px] flex cursor-pointer items-center w-full" style={itemStyle}>
              {route.icon && <span className={textClass}>{route.icon}</span>}
              <p className={`leading-1 ml-4 flex ${textClass}`}>
                {route.name}
              </p>
            </li>
          </div>
        </Link>
      );
    });
  };

  return <div className="mt-3 h-full">{renderMenuItems(routes || [])}</div>;
};

export default Sidebar;
